import { styleTags, tags } from '@lezer/highlight';

export const liquidStyleTags = styleTags({
  Boolean: tags.bool,
  'LiquidTagOpen LiquidTagClose LiquidObjectOpen LiquidObjectClose ParenOpen ParenClose': tags.propertyName,
  Filters: tags.color,
  FilterArg: tags.number,
  Identifier: tags.variableName,
  Index: tags.integer,
  'IndexOpen IndexClose': tags.moduleKeyword,
  LiquidFilterSeparator: tags.color,
  Number: tags.integer,
  Operator: tags.moduleKeyword,
  Property: tags.propertyName,
  TagName: tags.function(tags.moduleKeyword),
  String: tags.string,
  Text: tags.tagName
});
